import { NotificationState } from './types';

export const selectNotificationState = (state): NotificationState => state.notifications;

export const selectNotifications = state => {
  const { notifications } = selectNotificationState(state);
  return notifications;
};
